import * as Sentry from "@sentry/vue";

export default {
  actions: {
    logError(store, error) {
      console.error(error);
      Sentry.captureException(error);
    }
  }
}